<template>
  <table class="bar-table" :class="{compact: compact === true}">
    <tr v-for="(item, index) in items" :key="index">
      <td class="bar-table__title">{{item.title}}</td>
      <td style="width: 100%; padding-left: 0.0em; padding-right: 0em;">
        <div style="width: 100%; background: #f3f3f3; height: 1px; border-radius: 0.3em;">
          <div style="border-radius: 0.3em; height: 0.6em; position: relative; top: -0.2em;" :style="{ background: item.color, width: item.percentage }"><div style="color: #666; position: absolute;top: -0.39em; left: 100%; font-size: 0.9em; margin-left: 0.5em;" class="white-drop">{{item.percentage}}</div></div>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'BarChart',
  props: {
    items: {
      type: Array,
      required: true
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="scss">
  table.bar-table {
    width: 100%;
    font-size: 0.85rem;
    font-weight: 500;
    @media (max-width: 575px) {
      display: block;
      tr {
        display: block;
        margin-bottom: 1em;
        td, th {
          display: inline-block;
          &:last-child {
            display: block;
          }
        }
      }
    }
    &.compact {
      display: block;
      tr {
        display: block;
        margin-bottom: 1em;
        td, th {
          display: inline-block;
          &:last-child {
            display: block;
          }
        }
      }
    }
    .bar-table__title {
      width: auto;
      white-space: auto;
      padding: 0 1.0em 0.6em 0;
      font-weight: 700;
      line-height: 1.1;
      @media (min-width: 576px) {
        white-space: nowrap;
      }
    }
  }
  .white-drop {
    text-shadow: white 0px 0px 1px, white 0px 0px 2px, white 0px 0px 3px, white 0px 0px 4px, white 0px 0px 4px, white 0px 0px 5px, white 0px 0px 6px, white 0px 0px 7px, white 0px 0px 8px, white 0px 0px 9px
  }
</style>
